import React from "react";
import { FacilityOrderPatientNewFlowUSIntakeSinglePagePreviewTemplate } from "themes/application/facility-order-new-flow-us-intake-single-page/components";
import { FacilityOrderPatientNewFlowUSIntakeSinglePagePreviewViewStore } from 'application/facility-order-new-flow-us-intake-single-page/stores';
import { observer } from "mobx-react";
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore, componentProps) => new FacilityOrderPatientNewFlowUSIntakeSinglePagePreviewViewStore(rootStore, componentProps), 'facilityOrderPatientNewFlowUSIntakeSinglePagePreviewViewStore')
@observer
class FacilityOrderPatientNewFlowUSIntakeSinglePagePreview extends React.Component {
	render() {
		return <FacilityOrderPatientNewFlowUSIntakeSinglePagePreviewTemplate {...this.props} />;
	}
}

export default FacilityOrderPatientNewFlowUSIntakeSinglePagePreview;